export default {
  variants: {
    size: {
      sm: {
        base: 'px-1.5 text-nowrap gap-0.5',
        leadingIcon: 'size-3',
      },
    },
  },
}